var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',{staticClass:"subtitle"},[_vm._v("Orden: "+_vm._s(_vm.code))]),_c('button',{staticClass:"button is-success",on:{"click":_vm.restart}},[_vm._v("Reiniciar Estado")])])}
var staticRenderFns = []

export { render, staticRenderFns }